import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './AuthContext'; // Import AuthProvider
import reportWebVitals from './reportWebVitals';
// In index.js or App.js
// import 'bootstrap/dist/css/bootstrap.min.css';
import { unregister } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* Wrap the app in AuthProvider */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);
unregister(); // ✅ Register PWA
reportWebVitals();
